"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MulticallBaseAdapter = void 0;
const Throttle = __importStar(require("promise-parallel-throttle"));
class MulticallBaseAdapter {
    constructor(adapter) {
        this.adapter = adapter;
    }
    get isMulticallSupported() {
        var _a;
        return (_a = this.adapter.blockchainConfig.multicall) === null || _a === void 0 ? void 0 : _a.supported;
    }
    groupResultsByAmount(size) {
        return (results) => {
            const groupedResults = [];
            while (results.length !== 0) {
                groupedResults.push(results.splice(0, size));
            }
            return groupedResults;
        };
    }
    executeGrouped(useCaseGroups, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const useCases = useCaseGroups.reduce((list, group) => [...list, ...group], []);
            if (useCaseGroups.length === 0) {
                return [];
            }
            return this.execute(useCases, options).then(this.groupResultsByAmount(useCaseGroups[0].length));
        });
    }
    execute(useCases, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const promises = useCases.map((useCase) => () => useCase.execute(this.adapter, { blockHeight: options.blockHeight }));
            const { taskResults } = yield Throttle.raw(promises, {
                maxInProgress: 2,
            });
            return taskResults;
        });
    }
}
exports.MulticallBaseAdapter = MulticallBaseAdapter;
